export const decapitalize = (word: string): string =>
  word.replace(/(^\w)/g, (match: string) => match.toLowerCase());

export const openExtensionUrl = (): void => {
  const url =
    'https://chrome.google.com/webstore/detail/read4speed/gemlhgphcdpfenohdkmmbekahhebkach';
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};
